import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";

class ChatBotService {

    static sendMessage(data) {
        return axiosInstance.post(
            `${API_BASE_URL}${API_PATHS.chatbotMessage}`,
            data
        );
    }

}

export default ChatBotService;